import { createReducer } from '@reduxjs/toolkit';
import { ManualHotCase, CaseType } from '@rapid-recovery-agency-inc/insightt-shared';

import {
  addVehicleToManualHotListAction,
  fetchHLVehiclesByVIN,
  fetchManualHotListAction,
  removeManualHotListAction,
  updateManualHotCaseAction,
} from './manual-hot-cases-actions';
import { CLEAR_VEHICLES } from './manual-hot-cases-constants';

export interface ManualHotCaseReducer {
  manualHotCases: ManualHotCase[];
  manualHotCasesLoading: boolean;
  hotListVehicles: CaseType[];
  searchedHotListVehicles: boolean;
}

const INITIAL_STATE = {
  manualHotCases: [],
  manualHotCasesLoading: true,
  hotListVehicles: [],
  searchedHotListVehicles: false,
};

export default createReducer<ManualHotCaseReducer>(INITIAL_STATE, (builder) => {
  builder
    .addCase(fetchManualHotListAction.fulfilled, (state, action) => {
      return {
        ...state,
        manualHotCases: action.payload.manualHotCases,
        manualHotCasesLoading: false,
      } as ManualHotCaseReducer;
    })
    .addCase(fetchManualHotListAction.rejected, (state) => {
      return {
        ...state,
        manualHotCases: [],
        manualHotCasesLoading: false,
      };
    })
    .addCase(fetchHLVehiclesByVIN.fulfilled, (state, action) => {
      if (action?.payload)
        return {
          ...state,
          hotListVehicles: action.payload.hotListVehicles,
          searchedHotListVehicles: true,
        } as ManualHotCaseReducer;
      else return state;
    })
    .addCase(fetchHLVehiclesByVIN.rejected, (state) => {
      return { ...state, searchedHotListVehicles: false, hotListVehicles: [] };
    })
    .addCase(addVehicleToManualHotListAction.fulfilled, (state, action) => {
      return {
        ...state,
        manualHotCases: [action?.payload?.createOneManualHotCase, ...state.manualHotCases],
        manualHotCasesLoading: false,
        searchedHotListVehicles: false,
        hotListVehicles: [],
      };
    })
    .addCase(removeManualHotListAction.fulfilled, (state, action) => {
      return {
        ...state,
        manualHotCases: state.manualHotCases?.filter((item) => item.id !== action.payload.id),
        manualHotCasesLoading: false,
      };
    })
    .addCase(updateManualHotCaseAction.fulfilled, (state, action) => {
      const newItem = action.payload.updateOneManualHotCase;
      const index = state.manualHotCases?.findIndex((item) => item.id === newItem.id);
      const newArr = [...state.manualHotCases];
      newArr[index] = newItem;
      return {
        ...state,
        manualHotCases: newArr,
        manualHotCasesLoading: false,
      };
    })
    .addCase(CLEAR_VEHICLES, (state) => {
      return {
        ...state,
        hotListVehicles: [],
        searchedHotListVehicles: false,
      };
    })
    // -- default --
    .addDefaultCase((state) => state);
});
